import React, { useEffect, useRef, useState } from "react";
import { Table } from "../../components/Table/Table";
import {
  delete_icon,
  edit_icon,
  no_image,
  search_icon,
  view_icon,
} from "../../assets/imgs";
import {
  admin_list,
  Suspended_Property_list,
  Transaction_list,
} from "../redux/api/dummyJson";
import CancelIcon from "@mui/icons-material/Cancel";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import moment from "moment";
import {
  useLazyPropertiesListDropQuery,
  useLazyTotalLocationsListQuery,
  useSubscriptionListMutation,
  useSuspendedPropertyMutation,
  useUnsuspendedPropertyMutation,
} from "../redux/api/api";
import CustomSearchSelect from "../../components/Searchbox/CustomSearch";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const SuspendedProperty = () => {
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);
  const [pageno, setPageno] = useState(1);
  const [pagecount, setPagecount] = useState("");
  const [name, setName] = useState("");
  const [count, setCount] = useState();
  const [list, setList] = useState([]);
  const [reviewableId, setReviewableId] = useState("");

  const [fromdate, setFromDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [search, setSearch] = useState("");
  const [properties, setProperties] = useState([]);
  const [selectedPropertyId, setSelectedPropertyId] = useState("");
  const [propertyId, setPropertyId] = useState("");
  const [ownerId, setOwnerId] = useState("");

  const rolePermissions = JSON.parse(localStorage.getItem("permissions"));

  const [suspendedListApi] = useSuspendedPropertyMutation();
  const [unSuspendedListApi] = useUnsuspendedPropertyMutation();
  const [getCityApi] = useLazyTotalLocationsListQuery();
  const [getPropertyApi] = useLazyPropertiesListDropQuery();

  const suspendedList = (
    fromdate,
    toDate,
    selectedPropertyId,
    search,
    pageno
  ) => {
    const formdata = new FormData();
    formdata.append("page", pageno);
    formdata.append("per_page", 10);
    if (fromdate && toDate) {
      formdata.append("from_date", moment(fromdate).format("YYYY-MM-DD"));
      formdata.append("to_date", moment(toDate).format("YYYY-MM-DD"));
    }
    if (selectedPropertyId) {
      formdata.append("property_name", selectedPropertyId);
    }
    // if (selectedCityId) {
    //     formdata.append("city_id", selectedCityId)
    // }
    if (search) {
      formdata.append("search", search);
    }
    formdata.append("row", 10);
    setFromDate(fromdate);
    setToDate(toDate);
    // setCity(city)
    setProperties(properties);
    setSearch(search);
    suspendedListApi(formdata)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        let temp = [];
        let ids = []; // collect property IDs
        res?.data?.map((item, ind) => {
          let obj = { ...item };
          obj.current_page = res?.pagination?.current_page;
          temp.push(obj);

          // collect property_id
          if (item.property_id) {
            ids.push(item.property_id);
          }
        });
        setList(temp);
        setPagecount(res?.pagination);
        setCount(res?.pagination?.total);

        console.log("Property IDs:", ids); // <-- here are your property IDs
      })

      .catch((err) => {
        console.log("err",err);
      });
  };

  const unSuspendProperty = () => {
    if (!name) {
      toast.error("Enter the Reason");
      return;
    }

    const propertyIds = list.map((item) => item.property_id);
    const revieable_ids = list.map((item) => item.id);

    const formdata = new FormData();
    formdata.append("reason", name);

    formdata.append("property_ids", JSON.stringify(propertyIds));

    formdata.append("property_id", propertyId);
    formdata.append("owner_id", ownerId);
 formdata.append("reviewable_id", reviewableId); 
    unSuspendedListApi(formdata)
      .unwrap()
      .then((res) => {
        setPopup(false);
        suspendedList(fromdate, toDate, selectedPropertyId, search, pageno);
        toast.success(res?.message);
        setName("");
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getProperties = () => {
    getPropertyApi()
      .unwrap()
      .then((res) => {
        console.log(res);
        setProperties(res?.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    suspendedList(
      fromdate,
      toDate,
      selectedPropertyId,
      // selectedCityId,
      search,
      pageno
    );
    // getLocations()
    getProperties();
  }, [pageno]);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>
          );
        },
      },
      {
        Header: "Booking ID",
        accessor: "booking",
        Cell: ({ value, row }) => {
          return <p>{value?.booking_id}</p>;
        },
      },
      {
        Header: "Property Name",
        accessor: "property",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              {" "}
              <p
                className="pointer hoverline"
                onClick={() =>
                  navigate("/property-view", {
                    state: { data: row?.original?.property },
                  })
                }
              >
                {value?.name}
              </p>
            </div>
          );
        },
      },
      {
        Header: "Owner Name",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              {" "}
              <p
                className="pointer hoverline"
                onClick={() =>
                  navigate("/owner-view", {
                    state: {
                      type: "view",
                      id: row?.original?.property?.owner?.id,
                    },
                  })
                }
              >
                {row?.original?.property?.owner?.name}
              </p>
            </div>
          );
        },
      },
      {
        Header: "City",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{row?.original?.property?.city?.name}</p>;
        },
      },
      {
        Header: "user",
        accessor: "user",
        Cell: ({ value, row }) => {
          return <p>{value?.name}</p>;
        },
      },
      // {
      //     Header: "rating",
      //     accessor: "rating",
      //     Cell: ({ value, row }) => {
      //         return <p>{value}</p>;
      //     },
      // },
      {
        Header: "Status",
        accessor: "action",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              {rolePermissions?.includes("CAN-STATUS-SUSPENDED PROPERTY") && (
                <div className="d-flex ac-jc gap-2">
                  <button
                    onClick={() => {
                      setPopup(true);
                      setPropertyId(row?.original?.property_id);
                      setOwnerId(row?.original?.property?.owner?.id);
                       setReviewableId(row?.original?.id);
                    }}
                    className="cust-btn susp-btn"
                  >
                    <p className="mb-0">Unsuspend</p>
                  </button>
                </div>
              )}
            </React.Fragment>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc">
                {/* {rolePermissions?.includes('CAN-VIEW-OWNER') && */}
                <button
                  onClick={() =>
                    navigate("/suspended-property-view", {
                      state: { type: "view", data: row.original },
                    })
                  }
                  className="cust-btn "
                >
                  <img src={view_icon} alt="" className="mx-2 edit-btn " />
                </button>
                {/* } */}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    []
  );

  return (
    <div className="dashRightView home_section">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
          Suspended Property ({count})
        </h2>
      </div>
      <div className="d-flex ac-jb mt-3 gap-2">
        <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 primary">
          From Date
        </label>
        <div className="w-15">
          <DatePicker
            type="date"
            dateFormat="dd-MM-yyyy"
            className="input-pop-new ps-2 w-100"
            placeholderText="From Date"
            selected={fromdate}
            onChange={(e) => {
              suspendedList(
                e,
                toDate,
                selectedPropertyId,
                // city,
                search,
                1
              );
            }}
          />
        </div>
        <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 primary">
          To Date
        </label>
        <div className="w-15">
          <DatePicker
            type="date"
            dateFormat="dd-MM-yyyy"
            className="input-pop-new ps-2 w-100"
            placeholderText="To Date"
            selected={toDate}
            onChange={(e) =>
              suspendedList(
                fromdate,
                e,
                selectedPropertyId,
                // city,
                search,
                1
              )
            }
          />
        </div>
        <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 primary">
          Property{" "}
        </label>
        <CustomSearchSelect
          options={properties}
          value={selectedPropertyId}
          onChange={(propValue) => {
            setSelectedPropertyId(propValue);
            suspendedList(
              fromdate,
              toDate,
              propValue,
              // city,
              search,
              1
            );
          }}
          placeholder="Select Property"
          width="200px"
        />
        {/* <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 primary">City</label>
                    <CustomSearchSelect
                        options={cities}
                        value={selectedCityId}
                        onChange={(value) => {
                            setSelectedCityId(value);
                            suspendedList(
                                1,
                                fromdate,
                                toDate,
                                selectedPropertyId,
                                value,
                                search,
                            );
                        }}
                        placeholder="Select City"
                        width="165px"
                    /> */}
        <div
          onChange={(e) =>
            suspendedList(
              fromdate,
              toDate,
              selectedPropertyId,
              e.target.value,
              1
            )
          }
          className="search-input"
        >
          <input
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "100px" }}
          />
          <img src={search_icon} className="search" />
        </div>
      </div>

      <Table
        columns={columns}
        data={list}
        setPageno={setPageno}
        pagecount={pagecount}
        show={true}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-je">
              <button className="cust-btn" onClick={() => setPopup(false)}>
                <CancelIcon />
              </button>
            </div>
            <h4 className="f1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Send Notification to Owner
            </h4>
            <textarea
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="input-pop ps-2 w-100"
              placeholder="Category Name"
            />

            <div style={{ textAlign: "center", marginTop: "30px" }}>
              <button
                onClick={() => unSuspendProperty()}
                className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SuspendedProperty;
